import { Component, Shark } from "shark-mvc";

class DisableActionButtonComponent extends Component {
	constructor() {
		super("disableActionButtonComponent");
	}

	autoDisableActionBtn_clickHandler (event) {
		event.target.classList.remove("btn-primary");
		event.target.classList.add("btn-warning");
		event.target.disabled = true;
		event.target.dataset.originalContent = event.target.innerHTML;
		event.target.innerHTML = "Attendi...";
	}

	resetStatus (target) {
		if (target.disabled) {
			target.classList.add("btn-primary");
			target.classList.remove("btn-warning");
			target.disabled = false;
			target.innerHTML = target.dataset.originalContent;
		}
		else {
			setTimeout(() => {
				this.resetStatus(target);
			}, 250);
		}
	}
}

const disableActionButtonComponent = new DisableActionButtonComponent();

Shark.registerComponent(disableActionButtonComponent);

export default disableActionButtonComponent;
